import { create } from 'zustand';
import * as Sentry from '@sentry/react';
import securePersist from '@/utils/securePersist';

interface AuthState {
  accessToken: string | null;
  impersonating?: boolean;
  setTokens: (accessToken: string) => void;
  SetImpersonating: (impersonating: boolean) => void;
  clearTokens: () => void;
}

export const authStore = create<AuthState>()(
  securePersist(
    (set) => ({
      accessToken: null,
      impersonating: false,
      setTokens: (accessToken) => set({ accessToken }),
      SetImpersonating: (impersonating) => set({ impersonating }),
      clearTokens: () => {
        // Clear Sentry user context on logout
        Sentry.setUser(null);
        set({ accessToken: null, impersonating: false });
      },
    }),
    { name: 'auth-store' },
  ),
);
